var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal custom-modal fade",
      attrs: { id: "search_form", role: "dialog" }
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog modal-dialog-centered modal-lg",
          attrs: { role: "document" }
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c("h5", { staticClass: "modal-title" }, [
                _vm._v("Search Options")
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  ref: "dismisModal",
                  staticClass: "close",
                  attrs: {
                    type: "button",
                    "data-dismiss": "modal",
                    "aria-label": "Close"
                  }
                },
                [
                  _c("span", { attrs: { "aria-hidden": "true" } }, [
                    _vm._v("×")
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-12" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-md-6" }, [
                          _c("div", { staticClass: "form-group row" }, [
                            _c(
                              "label",
                              { staticClass: "col-form-label col-md-4" },
                              [_vm._v("From")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-8" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.formParam.columnFilters.start_date,
                                    expression:
                                      "formParam.columnFilters.start_date"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: { type: "date" },
                                domProps: {
                                  value: _vm.formParam.columnFilters.start_date
                                },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.formParam.columnFilters,
                                      "start_date",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-6" }, [
                          _c("div", { staticClass: "form-group row" }, [
                            _c(
                              "label",
                              { staticClass: "col-form-label col-md-4" },
                              [_vm._v("To")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-8" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.formParam.columnFilters.end_date,
                                    expression:
                                      "formParam.columnFilters.end_date"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: { type: "date" },
                                domProps: {
                                  value: _vm.formParam.columnFilters.end_date
                                },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.formParam.columnFilters,
                                      "end_date",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-12" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-md-6" }, [
                          _c("div", { staticClass: "form-group row" }, [
                            _c(
                              "label",
                              { staticClass: "col-form-label col-md-4" },
                              [_vm._v("Marketplace")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-md-8" },
                              [
                                _c("multiselect", {
                                  attrs: {
                                    placeholder: "Marketplace",
                                    options: _vm.dataListMarketplace,
                                    multiple: true,
                                    taggable: true
                                  },
                                  model: {
                                    value: _vm.formParam.mpIds,
                                    callback: function($$v) {
                                      _vm.$set(_vm.formParam, "mpIds", $$v)
                                    },
                                    expression: "formParam.mpIds"
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-6" }, [
                          _c("div", { staticClass: "form-group row" }, [
                            _c(
                              "label",
                              { staticClass: "col-form-label col-md-4" },
                              [_vm._v("Status")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-8" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.formParam.columnFilters
                                          .status_value,
                                      expression:
                                        "formParam.columnFilters.status_value"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.formParam.columnFilters,
                                        "status_value",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("option", { domProps: { value: "" } }, [
                                    _vm._v("All")
                                  ]),
                                  _vm._v(" "),
                                  _vm.dataListMonitoringStatus.length
                                    ? _vm._l(
                                        _vm.dataListMonitoringStatus,
                                        function(row, idx) {
                                          return _c(
                                            "option",
                                            {
                                              key: idx,
                                              domProps: { value: row.id }
                                            },
                                            [_vm._v(_vm._s(row.label))]
                                          )
                                        }
                                      )
                                    : _vm._e()
                                ],
                                2
                              )
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-12" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-md-6" }, [
                          _c("div", { staticClass: "form-group row" }, [
                            _c(
                              "label",
                              { staticClass: "col-form-label col-md-4" },
                              [_vm._v("Brand")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-md-8" },
                              [
                                _c(
                                  "multiselect",
                                  {
                                    attrs: {
                                      id: "ajax",
                                      label: "name",
                                      "track-by": "id",
                                      placeholder: "Type to search Brand...",
                                      multiple: true,
                                      "open-direction": "bottom",
                                      "custom-label": _vm.customLabel,
                                      options: _vm.contactOptions,
                                      searchable: true,
                                      loading: _vm.isLoading,
                                      "internal-search": false,
                                      "close-on-select": false,
                                      "options-limit": 300,
                                      limit: 3,
                                      "limit-text": _vm.limitText,
                                      "max-height": 600,
                                      "show-no-results": true,
                                      "hide-selected": true,
                                      "show-labels": false
                                    },
                                    on: { "search-change": _vm.asyncFind },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "tag",
                                        fn: function(ref) {
                                          var option = ref.option
                                          var remove = ref.remove
                                          return [
                                            _c(
                                              "span",
                                              { staticClass: "custom__tag" },
                                              [
                                                _c("span", [
                                                  _vm._v(_vm._s(option.name))
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "custom__remove",
                                                    on: {
                                                      click: function($event) {
                                                        return remove(option)
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("❌")]
                                                )
                                              ]
                                            )
                                          ]
                                        }
                                      },
                                      {
                                        key: "clear",
                                        fn: function(props) {
                                          return [
                                            _vm.selectedContact.length
                                              ? _c("div", {
                                                  staticClass:
                                                    "multiselect__clear",
                                                  on: {
                                                    mousedown: function(
                                                      $event
                                                    ) {
                                                      $event.preventDefault()
                                                      $event.stopPropagation()
                                                      return _vm.clearAll(
                                                        props.search
                                                      )
                                                    }
                                                  }
                                                })
                                              : _vm._e()
                                          ]
                                        }
                                      }
                                    ]),
                                    model: {
                                      value: _vm.selectedContact,
                                      callback: function($$v) {
                                        _vm.selectedContact = $$v
                                      },
                                      expression: "selectedContact"
                                    }
                                  },
                                  [
                                    _vm._v(" "),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        attrs: { slot: "noResult" },
                                        slot: "noResult"
                                      },
                                      [_vm._v("Oops! No elements found.")]
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-6" }, [
                          _c("div", { staticClass: "form-group row" }, [
                            _c(
                              "label",
                              { staticClass: "col-form-label col-md-4" },
                              [_vm._v("Product")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-md-8" },
                              [
                                _vm.selectedContact.length
                                  ? _c(
                                      "multiselect",
                                      {
                                        attrs: {
                                          id: "ajax",
                                          label: "name",
                                          "track-by": "id",
                                          placeholder:
                                            "Type to search Product...",
                                          multiple: true,
                                          "open-direction": "bottom",
                                          "custom-label": _vm.customLabel,
                                          options: _vm.productOptions,
                                          searchable: true,
                                          loading: _vm.isLoading,
                                          "internal-search": false,
                                          "close-on-select": false,
                                          "options-limit": 300,
                                          limit: 3,
                                          "limit-text": _vm.limitText,
                                          "max-height": 600,
                                          "show-no-results": true,
                                          "hide-selected": true,
                                          "show-labels": false
                                        },
                                        on: {
                                          "search-change": _vm.asyncFindProduct
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "tag",
                                              fn: function(ref) {
                                                var option = ref.option
                                                var remove = ref.remove
                                                return [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "custom__tag"
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(option.name)
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "custom__remove",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return remove(
                                                                option
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [_vm._v("❌")]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            },
                                            {
                                              key: "clear",
                                              fn: function(props) {
                                                return [
                                                  _vm.selectedProduct.length
                                                    ? _c("div", {
                                                        staticClass:
                                                          "multiselect__clear",
                                                        on: {
                                                          mousedown: function(
                                                            $event
                                                          ) {
                                                            $event.preventDefault()
                                                            $event.stopPropagation()
                                                            return _vm.clearAll(
                                                              props.search
                                                            )
                                                          }
                                                        }
                                                      })
                                                    : _vm._e()
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          1857285805
                                        ),
                                        model: {
                                          value: _vm.selectedProduct,
                                          callback: function($$v) {
                                            _vm.selectedProduct = $$v
                                          },
                                          expression: "selectedProduct"
                                        }
                                      },
                                      [
                                        _vm._v(" "),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            attrs: { slot: "noResult" },
                                            slot: "noResult"
                                          },
                                          [_vm._v("Oops! No elements found.")]
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-12" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-md-6" }, [
                          _c("div", { staticClass: "form-group row" }, [
                            _c(
                              "label",
                              { staticClass: "col-form-label col-md-4" },
                              [_vm._v("Rating")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-8" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.formParam.columnFilters.rating,
                                      expression:
                                        "formParam.columnFilters.rating"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.formParam.columnFilters,
                                        "rating",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("option", { attrs: { value: "" } }, [
                                    _vm._v("⭐ All")
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { domProps: { value: 5 } }, [
                                    _vm._v("⭐ 5")
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { domProps: { value: 4 } }, [
                                    _vm._v("⭐ 4 ke atas")
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { domProps: { value: 3 } }, [
                                    _vm._v("⭐ 3 ke atas")
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { domProps: { value: 2 } }, [
                                    _vm._v("⭐ 2 ke atas")
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { domProps: { value: 1 } }, [
                                    _vm._v("⭐ 1 ke atas")
                                  ])
                                ]
                              )
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-6" }, [
                          _c("div", { staticClass: "form-group row" }, [
                            _c(
                              "label",
                              { staticClass: "col-form-label col-md-4" },
                              [_vm._v("Cek Username Toko")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-8" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.formParam.columnFilters
                                          .is_store_name,
                                      expression:
                                        "formParam.columnFilters.is_store_name"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  on: {
                                    change: [
                                      function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.$set(
                                          _vm.formParam.columnFilters,
                                          "is_store_name",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      },
                                      _vm.handleIsStoreName
                                    ]
                                  }
                                },
                                [
                                  _c("option", { attrs: { value: "" } }, [
                                    _vm._v("All")
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "ada" } }, [
                                    _vm._v("Sudah Ada")
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "tidak" } }, [
                                    _vm._v("Belum Ada")
                                  ])
                                ]
                              )
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-12" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-md-6" }, [
                          _c("div", { staticClass: "form-group row" }, [
                            _c(
                              "label",
                              { staticClass: "col-form-label col-md-4" },
                              [_vm._v("Username Toko")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-8" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.formParam.columnFilters.store_name,
                                    expression:
                                      "formParam.columnFilters.store_name"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "text",
                                  disabled:
                                    _vm.formParam.columnFilters.is_store_name ==
                                    "tidak"
                                },
                                domProps: {
                                  value: _vm.formParam.columnFilters.store_name
                                },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.formParam.columnFilters,
                                      "store_name",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-6" }, [
                          _c("div", { staticClass: "form-group row" }, [
                            _c(
                              "label",
                              { staticClass: "col-form-label col-md-4" },
                              [_vm._v("Produk Toko")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-8" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.formParam.columnFilters.product_name,
                                    expression:
                                      "formParam.columnFilters.product_name"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: { type: "text" },
                                domProps: {
                                  value:
                                    _vm.formParam.columnFilters.product_name
                                },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.formParam.columnFilters,
                                      "product_name",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-12" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-md-6" }, [
                          _c("div", { staticClass: "form-group row" }, [
                            _c(
                              "label",
                              { staticClass: "col-form-label col-md-4" },
                              [_vm._v("Harga Minimal")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-8" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.formParam.columnFilters
                                        .product_price_start,
                                    expression:
                                      "\n                            formParam.columnFilters.product_price_start\n                          "
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: { type: "number", min: "0" },
                                domProps: {
                                  value:
                                    _vm.formParam.columnFilters
                                      .product_price_start
                                },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.formParam.columnFilters,
                                      "product_price_start",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-6" }, [
                          _c("div", { staticClass: "form-group row" }, [
                            _c(
                              "label",
                              { staticClass: "col-form-label col-md-4" },
                              [_vm._v("Harga Maksimal")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-8" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.formParam.columnFilters
                                        .product_price_end,
                                    expression:
                                      "formParam.columnFilters.product_price_end"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: { type: "number", min: "0" },
                                domProps: {
                                  value:
                                    _vm.formParam.columnFilters
                                      .product_price_end
                                },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.formParam.columnFilters,
                                      "product_price_end",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-12" }, [
                      _c("div", { staticClass: "form-group row" }, [
                        _c(
                          "label",
                          { staticClass: "col-form-label col-md-2" },
                          [_vm._v("Link")]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-10" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.formParam.columnFilters.product_url,
                                expression:
                                  "formParam.columnFilters.product_url"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: { type: "text" },
                            domProps: {
                              value: _vm.formParam.columnFilters.product_url
                            },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.formParam.columnFilters,
                                  "product_url",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-12" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-12" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _vm.isSending == false
                          ? _c("center", [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-md btn-light",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.clearSearch($event)
                                    }
                                  }
                                },
                                [
                                  _c("i", { staticClass: "fa fa-trash" }),
                                  _vm._v(" Clear Filter\n                  ")
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-md btn-success",
                                  style: "margin-left:10px;",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.applySearch($event)
                                    }
                                  }
                                },
                                [
                                  _c("i", { staticClass: "fa fa-search" }),
                                  _vm._v(" Search\n                  ")
                                ]
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                ])
              ])
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1ca9aaa6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ca9aaa6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/monitoring/links/formBookmark.vue
// module id = null
// module chunks = 